var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { AnchorButton } from "@savvyinsure/react-ui";
import AppBody from "../components/AppBody";
import { FaPhoneAlt } from "react-icons/fa";
import Header from "../components/Header";
import Image from "../components/Image";
import RouteTitle from "../components/RouteTitle";
import { completedPage } from "../lib/Avo";
import useAffiliateConfig from "../hooks/useAffiliateConfig";
import useAppSelector from "../hooks/useAppSelector";
import useQuery from "../features/navigation/useQuery";
export default function CallToShopPage() {
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var helpPhoneNumber = useAffiliateConfig().helpPhoneNumber;
    var query = useQuery();
    var isClassicCar = query.get("reason") === "classic-car";
    var subText = isClassicCar
        ? "We do not yet offer online shopping for classic car insurance."
        : "We do not have online shopping for the types of insurance you selected.";
    var phoneNumber = isClassicCar ? "1-833-657-5338" : helpPhoneNumber;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(AppBody, null,
            React.createElement("div", { className: "mb-2 flex items-center justify-center bg-white-200 pb-5 pt-3" },
                React.createElement(Image, { src: "/assets/images/guy-on-phone.svg", alt: "", width: "155", height: "185" })),
            React.createElement("div", { className: "px-6" },
                React.createElement(RouteTitle, { className: "mb-6 text-center font-bold" }, "Please call us for your quotes!"),
                React.createElement("p", { className: "mb-6 text-center text-black-300" }, subText),
                React.createElement(AnchorButton, { href: "tel:+".concat(phoneNumber), target: "_parent", onClick: function (ev) {
                        completedPage(__assign(__assign({}, commonAnalyticsProperties), { selectedOption: ev.currentTarget.textContent, optionSelected: ev.currentTarget.textContent }));
                    } },
                    React.createElement(FaPhoneAlt, { className: "mr-2" }),
                    " Call ",
                    phoneNumber),
                React.createElement("p", { className: "mt-4 text-center text-sm text-black-300" },
                    React.createElement("span", { className: "mr-1 inline-block h-2 w-2 rounded-full bg-green" }),
                    "Licensed agents available 9am-9pm ET")))));
}
